/**
 * Updates the styling of sub-navigation tabs to indicate the active tab.
 * This function:
 * 1. Identifies the current page's slug and hash
 * 2. Adds a 'bold' class to navigation items that match the current location
 * 3. Forces page reload for hash links to ensure proper state
 * 
 * Should be called after DOM is loaded, typically during site initialization.
 */
export function forcePageReloadOnAnchorHrefClick() {
  const currentUrl = new URL(window.location.href);
  const currentPathname = currentUrl.pathname; // e.g. "/contact"
  const currentHash = window.location.hash; // e.g. "#form"

  const pathnameSegments = currentPathname.split('/').filter(Boolean);
  const activeSlug = pathnameSegments.length > 0 ? pathnameSegments[pathnameSegments.length - 1] : '';

  document.querySelectorAll('.subnav-block li').forEach(function(li) {
    const anchor = li.querySelector('a');
    if (!anchor) {
      return;
    }

    const href = anchor.getAttribute('href');
    // anchor-only links (e.g. "#form")
    if (href.charAt(0) === '#') {
      if (href === currentHash) {
        li.classList.add('bold');
      }
    } else {
      let linkUrl;
      try {
        linkUrl = new URL(href, window.location.origin);
      } catch (error) {
        console.error("Could not parse URL:", href, error);
        return;
      }
      const linkPathname = linkUrl.pathname; // e.g. "/contact"
      const linkSegments = linkPathname.split('/').filter(Boolean);
      const linkSlug = linkSegments.length > 0 ? linkSegments[linkSegments.length - 1] : '';
      const linkHash = linkUrl.hash;

      if (activeSlug === linkSlug) {
        // if current URL has a hash, highlight links with a matching hash, otherwise only embolden links without any hash.
        if ((currentHash && linkHash === currentHash) || (!currentHash && !linkHash)) {
          li.classList.add('bold');
        }
      }
    }

    // force page reload for any link containing an #anchor in its href
    if (href.indexOf('#') !== -1) {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = href;
        window.location.reload();
      });
    }
  });
}